import { render, staticRenderFns } from "./TermBlock.vue?vue&type=template&id=1057783e&scoped=true"
import script from "./TermBlock.vue?vue&type=script&lang=js"
export * from "./TermBlock.vue?vue&type=script&lang=js"
import style0 from "./TermBlock.vue?vue&type=style&index=0&id=1057783e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1057783e",
  null
  
)

export default component.exports